const ITEMS = [
    "Soulagement du coccyx",
    "Posture alignée",
    "Confort longue durée",
    "Télétravail",
    "Grossesse",
    "Conduite",
    "Mousse à mémoire de forme",
    "Garantie 30 nuits",
];

export default function Marquee() {
    return (
        <div data-testid="editorial-marquee" className="relative py-5 lg:py-7 bg-sage-soft border-y border-sage/10 overflow-hidden marquee-mask">
            <div className="marquee-track flex w-max items-center">
                {[0, 1].map((copy) => (
                    <div key={copy} aria-hidden={copy === 1} className="flex items-center">
                        {ITEMS.map((item, i) => (
                            <span key={i} className="flex items-center whitespace-nowrap">
                                <span className="font-serif italic text-xl lg:text-2xl text-sage px-6 lg:px-8">{item}</span>
                                <span className="w-1.5 h-1.5 rounded-full bg-terra shrink-0" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
